import React from "react";

const LoginPage: React.FC = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
        color: "#fff",
      }}
    >
      <div
        style={{
          background: "rgba(255, 255, 255, 0.95)",
          borderRadius: "16px",
          padding: "48px",
          maxWidth: "420px",
          width: "90%",
          textAlign: "center",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
        }}
      >
        <div
          style={{
            fontSize: "48px",
            marginBottom: "8px",
          }}
        >
          <svg width="48" height="48" viewBox="0 0 128 128" fill="none">
            <rect width="128" height="128" rx="24" fill="#6965db" />
            <path
              d="M40 88L64 40L88 88"
              stroke="white"
              strokeWidth="8"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
            />
            <circle cx="64" cy="64" r="8" fill="white" />
          </svg>
        </div>
        <h1
          style={{
            color: "#1a1a2e",
            fontSize: "24px",
            fontWeight: 600,
            margin: "16px 0 8px",
          }}
        >
          Surfboard Diagrams
        </h1>
        <p
          style={{
            color: "#666",
            fontSize: "14px",
            margin: "0 0 32px",
            lineHeight: 1.5,
          }}
        >
          Collaborative diagramming for the Surfboard team.
          <br />
          Sign in with your @surfboard.se account to get started.
        </p>
        <a
          href="/api/auth/google/login"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "12px",
            padding: "12px 24px",
            background: "#fff",
            border: "1px solid #dadce0",
            borderRadius: "8px",
            color: "#3c4043",
            fontSize: "15px",
            fontWeight: 500,
            textDecoration: "none",
            cursor: "pointer",
            transition: "box-shadow 0.2s, background 0.2s",
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.15)";
            e.currentTarget.style.background = "#f8f9fa";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.08)";
            e.currentTarget.style.background = "#fff";
          }}
        >
          <svg width="20" height="20" viewBox="0 0 48 48">
            <path
              fill="#EA4335"
              d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
            />
            <path
              fill="#4285F4"
              d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
            />
            <path
              fill="#FBBC05"
              d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
            />
            <path
              fill="#34A853"
              d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
            />
          </svg>
          Sign in with Google
        </a>
      </div>
    </div>
  );
};

export default LoginPage;
